@charset "UTF-8";

/* src/app/app.component.scss */
.searchpage {
}
.searchpage .primary-button {
  background-color: var(--accent-color);
  color: var(--button-hover);
}
.searchpage .primary-button:hover {
  background-color: --button-hover;
}
.searchpage .primary-button:active {
  background-color: --button-active;
}
.searchpage .primary-button.disabled {
  background-color: --button-inaktiv;
}
.searchpage .secondary-button {
  background-color: --secondary-button-normal;
}
.searchpage .secondary-button:hover {
  background-color: --secondary-button-hover;
}
.searchpage .secondary-button:active {
  background-color: --secondary-button-active;
}
.searchpage .secondary-button.disabled {
  background-color: --secondary-button-inaktiv;
}
.searchpage ion-button {
  border-radius: 5px;
}
.searchpage .green {
  font: "Kanit-ExtraLight";
  color: var(--termed-gruen);
}
.searchpage :root {
  --primary-color: #003f78;
  --secondary-color: #368b2b;
  --accent-color: #7acb48;
  --light-color: #f2f5f8;
  --dark-color: #666;
  --grid-columns: 12;
  --grid-gutter-width: 20px;
  --container-max-width: 1200px;
  --termed-blau: #003578;
  --termed-blau2: #79abbb;
  --termed-blau3: #0496c8;
  --termed-hellblau: #93deea;
  --termed-gruen: #7acb48;
  --termed-weiss: #ffffff;
  --termed-hellgrau: #f2f5f8;
  --termed-grau: #e0ebf1;
  --termed-verlauf-dunkelblau:
    linear-gradient(
      90deg,
      #0496c8,
      #003578);
  --termed-verlauf-hellblau:
    linear-gradient(
      90deg,
      #93deea,
      #0496c8);
  --termed-verlauf-gruen:
    linear-gradient(
      90deg,
      #93deea,
      #7acb48,
      #25aa8c);
  --termed-erfolg: #7acb48;
  --termed-information: #0496c8;
  --termed-warnung: #f5a823;
  --termed-gefahr: #d0021b;
  --button-normal: #7acb48;
  --button-hover: #fff;
  --button-active: #0496c8;
  --button-inaktiv: #c4d0d9;
  --secondary-button-normal: #ffffff;
  --secondary-button-hover: #fff;
  --secondary-button-active: #e0ebf1;
  --secondary-button-inaktiv: #c4d0d9;
}
.searchpage h1 {
  font-size: 4rem;
  font-family: "Kanit-SemiBold" !important;
  font-weight: bold;
}
@media only screen and (max-width: 768px) {
  .searchpage h1 {
    font-size: 2.25rem;
  }
}
.searchpage h2 {
  font-size: 3.45rem;
  font-family: "Kanit-SemiBold" !important;
  font-weight: bold;
}
@media only screen and (max-width: 768px) {
  .searchpage h2 {
    font-size: 1.75rem;
  }
}
.searchpage h3 {
  font-size: 2.2rem;
  font-family: "Kanit-SemiBold" !important;
  font-weight: bold;
}
@media only screen and (max-width: 768px) {
  .searchpage h3 {
    font-size: 1.5rem;
  }
}
.searchpage p {
  font-size: 1rem;
  font-family: "Kanit-ExtraLight" !important;
}
.searchpage p.alt {
  font-size: 0.88rem;
  font-family: "Kanit-ExtraLight" !important;
}
.searchpage h1,
.searchpage h2,
.searchpage h3,
.searchpage h4,
.searchpage h5,
.searchpage h6,
.searchpage p {
  color: var(--primary-color);
}
.searchpage .container {
  max-width: var(--container-max-width);
  margin: 0 auto;
  padding: 0 var(--grid-gutter-width);
}
.searchpage ion-menu {
  color: #000;
}
.searchpage .container {
  width: 90%;
  margin: 0 auto;
  max-width: var(--container-max-width);
}
.searchpage header {
  background: var(--primary-color);
  color: #003f78;
  padding: 20px 0;
}
.searchpage .header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.searchpage .logo ion-img {
  max-width: 150px;
}
.searchpage .topnav {
  color: #003578;
}
.searchpage nav ul {
  list-style: none;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
}
.searchpage nav ul li {
  position: relative;
  padding: 10px;
}
.searchpage nav ul li ion-item {
  color: #003578;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
  z-index: 1;
}
.searchpage nav ul li .dropdown-arrow {
  margin-left: 5px;
}
.searchpage .dropdown-menu {
  display: none;
  position: sticky;
  top: 100%;
  left: 0;
  background-color: white;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 10px 0;
  margin: 0;
  border-radius: 5px;
}
.searchpage .dropdown-menu li {
  padding: 8px 16px;
  white-space: nowrap;
}
.searchpage nav ul li:hover .dropdown-menu {
  display: block;
}
.searchpage button {
  color: #fff;
}
.searchpage html,
.searchpage body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.searchpage .wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.searchpage main {
  flex: 1;
}
.searchpage .login-buttons {
  color: #003f78 !important;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  margin-left: 10px;
  font-weight: bold;
}
.searchpage .login-buttons ion-img {
  width: 20px;
  height: auto;
  margin-right: 5px;
}
.searchpage .praxis-btn {
  color: #003f78 !important;
}
.searchpage .patient-btn {
  background-color: #368b2b;
  color: #003f78 !important;
}
.searchpage .bgp {
  background-image:
    linear-gradient(
      to right,
      rgb(255, 255, 255),
      rgba(200, 200, 200, 0.8)),
    url("browser/media/TerMed_Header_Startseite.png");
  background-size: cover;
  background-position: center;
  text-align: left;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp {
    background-size: 200%;
    background-repeat: no-repeat;
    background-position: top center;
  }
}
.searchpage .bgp .main-section {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  color: white;
}
.searchpage .bgp .main-section .text-content {
  max-width: 1200px;
  padding: 20px;
  justify-content: center;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content {
    max-width: 100%;
  }
}
.searchpage .bgp .main-section .text-content .text-content p {
  margin-bottom: 60px;
  width: 100%;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .text-content p {
    margin-bottom: 0px;
    width: 100%;
  }
}
.searchpage .bgp .main-section .text-content .header1 {
  font-size: 4rem;
  font-weight: regular;
  margin-bottom: 0.5rem;
  color: #003578;
  text-align: left;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 0px;
  margin-top: 60px;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .header1 {
    font-size: 2.25rem;
    margin-top: 0px;
  }
}
.searchpage .bgp .main-section .text-content .header2 {
  font-size: 4rem;
  font-weight: 400;
  margin-bottom: 1rem;
  background:
    linear-gradient(
      90deg,
      #a0e17d,
      #368b2b);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  margin-top: 0;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .header2 {
    font-size: 2.25rem;
  }
}
.searchpage .bgp .main-section .text-content p {
  color: #003578;
  text-align: left;
  width: 100%;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content p {
    max-width: 100%;
  }
}
.searchpage .bgp .main-section .text-content ion-button {
  margin: 0.5rem;
}
.searchpage .bgp .main-section .text-content ion-button.more {
  border: 1px solid #fff;
}
.searchpage .bgp .main-section .text-content .search-container {
  background-color: #fff;
  gap: 10px;
  padding: 10px;
  border: 2px solid #fff;
  border-radius: 10px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  color: #003f78;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .search-container {
    min-width: auto;
    max-width: none;
    width: 100%;
  }
}
.searchpage .bgp .main-section .text-content .search-fields {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  max-width: 1200px;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .search-fields {
    display: block;
    flex-wrap: wrap;
    max-width: 100%;
  }
}
.searchpage .bgp .main-section .text-content .radius-button-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  color: var(--primary-color);
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .radius-button-container {
    max-width: auto;
    min-width: 100px;
    width: 100%;
  }
}
.searchpage .bgp .main-section .text-content .radius-button-container ion-input {
  background: var(--light-color);
}
.searchpage .bgp .main-section .text-content ion-item {
  --background: #fff;
  border-radius: 15px;
  color: #007bff;
  height: 200px;
  width: 100;
  padding: 0 10px;
}
.searchpage .bgp .main-section .text-content ion-input {
  --padding-start: 10px;
  --padding-end: 10px;
  --background: transparent;
  border: none;
  border-radius: 15px;
  flex: 1;
  height: 100%;
  color: inherit;
  font-size: small;
}
.searchpage .bgp .main-section .text-content ion-label {
  color: var(--primary-color);
  font-size: small;
}
.searchpage .bgp .main-section .text-content .search-button {
  width: 50px;
  height: 50px;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .search-button {
    width: 100%;
  }
}
.searchpage .bgp .main-section .text-content .results-container {
  display: flex;
  gap: 10px;
  height: auto;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .main-section .text-content .results-container {
    max-width: 200px;
  }
}
.searchpage .bgp .main-section .text-content .search-results-row,
.searchpage .bgp .main-section .text-content .zip-results-row {
  flex: 1;
  height: auto;
}
.searchpage .bgp .main-section .registerbutton {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 40px !important;
}
.searchpage .bgp .info-boxes {
  margin-top: 20px;
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  justify-content: center;
}
.searchpage .bgp .info-boxes .cardsinfo {
  min-height: 320px;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp .info-boxes .cardsinfo {
    min-height: auto;
  }
}
.searchpage .bgp ion-card-title {
  font-weight: bold;
  color: #003578;
  font-size: 1rem;
}
.searchpage .bgp ion-card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.searchpage .bgp ion-img {
  width: 50px;
  height: 50px;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 768px) {
  .searchpage .bgp ion-img {
    width: 30px;
    height: 30px;
    margin-bottom: 5px;
  }
}
.searchpage .bgp ion-card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.searchpage .bgp .button-container {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-top: 20px;
  margin-left: 200px;
}
.searchpage .bgp .button-left {
  display: flex;
  justify-content: flex-start;
}
.searchpage .articles {
  width: 1200px;
  margin: 60px auto 0;
}
.searchpage .articles ion-card {
  --background: #fff;
  border-radius: 10px;
  min-width: 320px;
  min-height: 330px;
  margin: 20px;
  text-align: left;
  font: "Kanit-ExtraLight";
  color: #003578;
}
.searchpage .articles ion-card ion-card-header ion-card-title {
  color: #003578;
  font: "Kanit-ExtraLight";
  font-weight: bold;
  text-align: left;
}
.searchpage .articles .news-content {
  padding: 10px;
}
.searchpage .articles .news-content h3 {
  font-size: 1.2em;
  margin: 0;
}
.searchpage .articles .news-content p {
  font-size: 0.9em;
  color: gray;
}
@media (max-width: 1200px) {
  .searchpage .articles .news-content {
    flex: 0 0 calc(33.33% - 30px);
  }
}
@media (max-width: 768px) {
  .searchpage .articles .news-content {
    flex: 0 0 calc(50% - 30px);
  }
}
@media (max-width: 480px) {
  .searchpage .articles .news-content {
    flex: 0 0 100%;
  }
}
.searchpage ion-button.secondary-btn {
  align-self: flex-end;
}
.searchpage .secondary-btn {
  background-color: var(--button-hover);
  color: var(--primary-color);
}
.searchpage .secondary-btn:hover {
  background-color: var(--button-normal);
  color: var(--secondary-button-normal);
}
.searchpage .secondary-btn:active {
  background-color: var(--button-active);
}
.searchpage .secondary-btn:disabled {
  background-color: var(--button-inaktiv);
  color: var(--secondary-button-inaktiv);
}
.searchpage #products {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #f9f9f9;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.searchpage #products .container {
  display: flex;
  width: 100%;
  position: relative;
  z-index: 1;
}
.searchpage #products .content-container {
  flex: 1;
  margin-right: 20px;
}
.searchpage #products .content-container .text-content {
  color: #003578;
  margin-bottom: 20px;
  width: 50%;
}
@media only screen and (max-width: 768px) {
  .searchpage #products .content-container .text-content {
    max-width: none;
    min-width: 100px;
    width: 100%;
  }
}
.searchpage #products .content-container .text-content h2,
.searchpage #products .content-container .text-content p {
  width: 100%;
  max-width: 550px;
}
.searchpage #products .content-container .products-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.searchpage #products .content-container .products-list ion-card {
  --background: #fff;
  border-radius: 10px;
  max-width: 550px;
  text-align: left;
  color: #003578;
}
.searchpage #products .content-container .products-list ion-card ion-card-header ion-card-title {
  color: #003578;
}
.searchpage #products .content-container .products-list ion-card ion-card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.searchpage #products .content-container .products-list ion-card ion-card-content p {
  margin: 0;
  flex: 1;
  width: auto;
}
.searchpage #products .content-container .products-list ion-card ion-card-content ion-button {
  margin-left: 10px;
  flex-shrink: 0;
}
.searchpage #products::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 52%;
  height: 80%;
  background: url("browser/media/TerMed_Produkte-Startseite.png") no-repeat;
  background-size: cover;
  background-position: left;
  z-index: 0;
}
@media only screen and (max-width: 768px) {
  .searchpage #products::before {
    background: none;
  }
}
.searchpage .about {
  background-color: #f2f5f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  flex-wrap: wrap;
}
@media only screen and (max-width: 768px) {
  .searchpage .about {
    text-align: left;
  }
}
.searchpage .about .text-content {
  color: #003578;
  max-width: 50%;
}
.searchpage .about .segment-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  margin: 20px 0;
  display: inline-block;
}
.searchpage .about img {
  max-width: 45%;
  border-radius: 10px;
}
.searchpage .advantages {
  background-color: #f2f5f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  flex-wrap: wrap;
  text-align: center;
}
.searchpage .advantages .header1 {
  text-align: center;
}
.searchpage .advantages .header1 g {
  font-family: "Kanit-SemiBold" !important;
  background:
    linear-gradient(
      90deg,
      #a0e17d,
      #368b2b);
  background-clip: border-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}
.searchpage .advantages .header-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}
.searchpage .advantages .titles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}
@media only screen and (max-width: 768px) {
  .searchpage .advantages .titles {
    display: block;
  }
}
.searchpage .advantages .titles h3 {
  margin: 5px;
  font-size: 2.25rem;
}
.searchpage .advantages .text-content {
  color: #003578;
  max-width: 50%;
  text-align: left;
}
.searchpage .advantages .segment-wrapper {
  background-color: #fff;
  width: auto;
  border-radius: 8px;
  padding: 10px;
  margin: 20px 0;
  display: block;
}
.searchpage .advantages ion-segment-button {
  color: #003f78 !important;
  text-decoration: none;
  font-weight: bold;
}
.searchpage .advantages ion-segment-button ion-img {
  width: 20px;
  height: auto;
}
.searchpage .advantages img {
  max-width: 45%;
  border-radius: 10px;
}
.searchpage .advantages .secondary-btn {
  background-color: var(--termed-weiss);
  color: var(--primary-color);
}
.searchpage .advantages .secondary-btn:hover {
  background-color: var(--termed-weiss);
  color: var(--button-hover);
}
.searchpage .advantages .secondary-btn:active {
  background-color: var(--termed-weiss);
}
.searchpage .advantages .secondary-btn:disabled {
  background-color: var(--termed-weiss);
  color: var(--button-inaktiv);
}
.searchpage .pre {
  font: "Kanit-ExtraLight";
  color: var(--termed-gruen);
}
.searchpage p.pre {
  margin: 0;
}
.searchpage h2.pre {
  margin-top: 5px;
  color: inherit;
}
.searchpage .moreinfo {
  background: var(--termed-hellgrau);
}
.searchpage .moreinfo .container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
@media only screen and (max-width: 768px) {
  .searchpage .moreinfo {
    margin-left: inherit;
    width: 100%;
  }
}
.searchpage .moreinfo .text {
  font: "Kanit-ExtraLight";
  color: var(--primary-color);
}
.searchpage .moreinfo a {
  text-decoration: none;
  margin: 20px 0;
}
.searchpage .hide-on-mobile {
  display: none;
}
.searchpage .termmed-app {
  background: url("browser/media/BlauerBG-Verlauf_00.jpg");
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  flex-wrap: wrap;
}
.searchpage .termmed-app .text-content {
  max-width: 50%;
}
.searchpage .termmed-app .text-content h6 {
  color: #7acb48;
}
.searchpage .termmed-app .text-content h2 {
  color: #fff;
}
.searchpage .termmed-app .text-content p {
  color: #f4f5f8;
  margin: 10px 0;
}
.searchpage .termmed-app img {
  max-width: 45%;
  border-radius: 10px;
}
.searchpage .container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;
}
.searchpage .about,
.searchpage .products,
.searchpage .advantages,
.searchpage .testimonials,
.searchpage .termmed-app {
  width: 100%;
  background-size: cover;
}
.searchpage img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}
.searchpage .text-content {
  max-width: 50%;
}
@media (max-width: 768px) {
  .searchpage {
  }
  .searchpage .main-section,
  .searchpage .about,
  .searchpage .career,
  .searchpage .advantages,
  .searchpage .termmed-app {
    flex-direction: column;
  }
  .searchpage .menu-logo {
    width: 100px;
  }
  .searchpage .mobile-nav-container {
    padding: var(--top-margin) var(--side-margins);
  }
  .searchpage .login-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--text-spacing);
  }
  .searchpage .login-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .searchpage .mobile-nav ul {
    list-style: none;
    padding: 0;
  }
  .searchpage .mobile-nav ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--text-spacing);
  }
  .searchpage .mobile-nav ul li ion-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .searchpage .social-buttons {
    display: block;
    justify-content: space-between;
    margin-bottom: var(--button-spacing);
    background-color: var(--accent-color);
    color: var(--light-color);
  }
  .searchpage .social-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1.25rem;
  }
  .searchpage .contact-button {
    text-align: center;
    color: white;
  }
  .searchpage .contact-button ion-button {
    color: white;
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .searchpage .articles {
    display: none;
  }
  .searchpage .topnav,
  .searchpage .more {
    display: none;
  }
  .searchpage .main-section .text-content,
  .searchpage .career .text-content,
  .searchpage .advantages .text-content,
  .searchpage .termmed-app .text-content {
    max-width: 100%;
    text-align: center;
  }
  .searchpage .about .text-content {
    max-width: 100%;
    text-align: left;
  }
  .searchpage .main-section img,
  .searchpage .about img,
  .searchpage .career img,
  .searchpage .advantages img,
  .searchpage .termmed-app img {
    max-width: 100%;
    margin-top: 20px;
  }
  .searchpage .products {
    flex-direction: column;
    text-align: center;
  }
  .searchpage .products .content-container {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .searchpage .products .product-image {
    max-width: 100%;
  }
  .searchpage .header-container {
    flex-direction: column;
    align-items: center;
  }
  .searchpage .login-buttons {
    margin-top: 10px;
  }
  .searchpage nav ul {
    flex-direction: column;
    gap: 10px;
  }
}
@media (max-width: 768px) {
  .searchpage {
  }
  .searchpage .main-section,
  .searchpage .about,
  .searchpage .career,
  .searchpage .advantages,
  .searchpage .termmed-app {
    flex-direction: column;
  }
  .searchpage .menu-logo {
    width: 100px;
  }
  .searchpage .mobile-nav-container {
    padding: var(--top-margin) var(--side-margins);
  }
  .searchpage .login-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--text-spacing);
  }
  .searchpage .login-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .searchpage .mobile-nav ul {
    list-style: none;
    padding: 0;
  }
  .searchpage .mobile-nav ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--text-spacing);
  }
  .searchpage .mobile-nav ul li ion-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .searchpage .social-buttons {
    display: block;
    justify-content: space-between;
    margin-bottom: var(--button-spacing);
  }
  .searchpage .social-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1.25rem;
  }
  .searchpage .contact-button {
    text-align: center;
    color: white;
  }
  .searchpage .contact-button ion-button {
    color: white;
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .searchpage .about .container {
    margin: 0;
    padding: 20px 0 0 0;
  }
  .searchpage .articles {
    display: none;
  }
  .searchpage .topnav,
  .searchpage .more {
    display: none;
  }
  .searchpage .main-section .text-content,
  .searchpage .career .text-content,
  .searchpage .advantages .text-content,
  .searchpage .termmed-app .text-content {
    max-width: 100%;
    text-align: center;
  }
  .searchpage .about .text-content {
    max-width: 100%;
    text-align: left;
  }
  .searchpage .main-section img,
  .searchpage .about img,
  .searchpage .career img,
  .searchpage .advantages img,
  .searchpage .termmed-app img {
    max-width: 100%;
    margin-top: 20px;
  }
  .searchpage .products {
    flex-direction: column;
    text-align: center;
  }
  .searchpage .products .content-container {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .searchpage .products .product-image {
    max-width: 100%;
  }
  .searchpage .header-container {
    flex-direction: column;
    align-items: center;
  }
  .searchpage .login-buttons {
    margin-top: 10px;
  }
  .searchpage nav ul {
    flex-direction: column;
    gap: 10px;
  }
}
@media (max-width: 768px) {
  .searchpage {
  }
  .searchpage .main-section,
  .searchpage .about,
  .searchpage .career,
  .searchpage .advantages,
  .searchpage .termmed-app {
    flex-direction: column;
  }
  .searchpage .menu-logo {
    width: 100px;
  }
  .searchpage .mobile-nav-container {
    padding: var(--top-margin) var(--side-margins);
  }
  .searchpage .login-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--text-spacing);
  }
  .searchpage .login-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .searchpage .mobile-nav ul {
    list-style: none;
    padding: 0;
  }
  .searchpage .mobile-nav ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--text-spacing);
  }
  .searchpage .mobile-nav ul li ion-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .searchpage .social-buttons {
    display: block;
    justify-content: space-between;
    margin-bottom: var(--button-spacing);
  }
  .searchpage .social-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1.25rem;
  }
  .searchpage .contact-button {
    text-align: center;
    color: white;
  }
  .searchpage .contact-button ion-button {
    color: white;
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .searchpage .articles {
    display: none;
  }
  .searchpage .topnav,
  .searchpage .more {
    display: none;
  }
  .searchpage .main-section .text-content,
  .searchpage .career .text-content,
  .searchpage .advantages .text-content,
  .searchpage .termmed-app .text-content {
    max-width: 100%;
    text-align: center;
  }
  .searchpage .about .text-content {
    max-width: 100%;
    text-align: left;
  }
  .searchpage .main-section img,
  .searchpage .about img,
  .searchpage .career img,
  .searchpage .advantages img,
  .searchpage .termmed-app img {
    max-width: 100%;
    margin-top: 20px;
  }
  .searchpage .products {
    flex-direction: column;
    text-align: center;
  }
  .searchpage .products .content-container {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .searchpage .products .product-image {
    max-width: 100%;
  }
  .searchpage .header-container {
    flex-direction: column;
    align-items: center;
  }
  .searchpage .login-buttons {
    margin-top: 10px;
  }
  .searchpage nav ul {
    flex-direction: column;
    gap: 10px;
  }
}
.searchpage .social-icons {
  display: flex;
  gap: 10px;
}
.searchpage .social-icons ion-img {
  width: 24px;
  height: 24px;
}
.searchpage .buttons {
  margin-top: 10px;
}
.searchpage .buttons ion-button ion-img {
  width: 20px;
  height: auto;
  margin-right: 5px;
}
.searchpage .legal-links li a {
  text-decoration: none;
  color: #003578;
}
.searchpage .legal-links li a:hover {
  text-decoration: underline;
}
.searchpage .circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.searchpage .circle.black {
  background-color: #000000;
}
.searchpage .circle.red {
  background-color: #FF0000;
}
.searchpage .circle.gold {
  background-color: #FFCC00;
}
.search-results {
  background-color: #ccdaeb;
  padding-bottom: 60px;
}
ion-toolbar ion-title {
  text-align: left;
  font-weight: 600;
  margin-left: 10px;
}
@media (max-width: 555px) {
  ion-toolbar ion-title {
    text-align: left;
    padding-right: 10px !important;
  }
}
.karte-button {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  cursor: pointer;
  padding-right: 15px;
}
.karte-text {
  font-weight: 600;
}
.no-results {
  text-align: center;
  margin: 40px 15px;
}
.no-results-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px;
}
.no-results-icon {
  font-size: 2.5rem;
  color: #0496c8;
}
.no-results-text {
  font-size: 1rem;
  font-weight: 500;
  color: #555;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  width: 100%;
}
ion-spinner {
  width: 60px;
  height: 60px;
}
.text-start {
  padding-left: 15px;
}
.no-padding {
  --inner-padding-end: 0;
  --padding-start: 0;
}
.label-margin,
.header-four {
  margin-left: 10px;
}
.dashboard {
  background-color: #ccdaeb !important;
}
.dashboard ion-segment {
  --background: #ffffff !important;
  color: #000000 !important;
}
.dashboard ion-segment ion-label {
  color: #000000;
}
.dashboard ion-segment.lightcolor {
  --background: #ffffff;
  color: #000000;
}
.dashboard next-appointements ion-list-header {
  border-bottom: none;
}
.dashboard next-appointements ion-list-header .label-md {
  margin-bottom: 3px;
}
.dashboard next-appointements p.stornoHint {
  white-space: normal;
}
.dashboard ion-card .next-doc-img {
  padding-right: 16px;
  padding-top: 16px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.dashboard ion-card .next-doc-typing {
  -webkit-box-flex: 2;
  -webkit-flex: 2;
  -ms-flex: 2;
  flex: 2;
  padding-top: 2px;
  padding-left: 0px;
}
.dashboard ion-card .next-doc-typing > ion-item {
  margin-bottom: 1px;
}
.dashboard ion-card .action,
.dashboard ion-card .cancel {
  padding: 0 0.6em;
}
.dashboard ion-card .label-md {
  margin: 0;
}
.dashboard .delfav {
  float: left;
  width: 10%;
  margin-top: 10px;
}
.dashboard a.linkfav.item-block {
  float: left;
  width: 80%;
}
.dashboard a.linkfav.item-block p {
  text-decoration: none;
}
.dashboard .line {
  border-bottom: solid 1px #eeeeee;
}
@media screen and (max-width: 768px) {
  .dashboard {
    background-color: #ccdaeb !important;
  }
}
.no-appointments {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 40px auto;
  width: 85%;
  max-width: 400px;
  --background: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
}
.no-appointments .no-appointments-icon {
  font-size: 46px;
  margin-bottom: 8px;
  color: var(--ion-color-medium);
}
.no-appointments .no-appointments-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 4px;
}
ion-segment.lightcolor ion-segment-button {
  --background: transparent;
  --color: #222121;
  --color-checked: #0078ff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.3px;
  border-bottom: 3px solid transparent;
  transition: border-color 0.25s ease, color 0.25s ease;
}
ion-segment.lightcolor ion-segment-button ion-label {
  padding-bottom: 6px;
  display: inline-block;
}
ion-segment.lightcolor ion-segment-button.segment-button-checked {
  border-bottom-color: #0078ff;
  color: #0078ff !important;
}
ion-segment.lightcolor ion-segment-button:not(.segment-button-checked) {
  opacity: 0.5;
}
ion-segment-button:not(.segment-button-checked) ion-label {
  opacity: 0.5;
  transition: opacity 0.2s ease;
}
ion-segment-button.segment-button-checked ion-label {
  opacity: 1;
}
.book-page textarea {
  max-width: 100%;
  width: 100%;
}
.book-page .hint-vss {
  font-style: italic;
  font-size: smaller;
}
.doctor-info {
  padding: 16px;
}
.doctitle {
  margin-top: 0;
  padding-top: 0;
}
.doctitle h2,
.doctitle h4,
.doctitle p {
  padding: 0;
  margin: 5px 0;
}
.doctitle p {
  font-weight: 600;
  color: #000000;
}
.doctor-info-appLogic {
  background: #e1ecff !important;
  background-color: #e1ecff !important;
  --ion-item-background:#e1ecff;
}
.badge {
  background: #ffffff !important;
  padding: 2px 15px !important;
  border: 1px solid #adadad !important;
  border-radius: 20px !important;
  font-size: 0.75rem !important;
  font-weight: bold !important;
  color: #333;
}
.requiredField {
  top: -5px !important;
}
ion-item.bottomMargin {
  margin-bottom: 5px !important;
}
.tablet-label {
  font-size: 1.2rem !important;
  color: #999 !important;
  margin-bottom: 8px !important;
}
.tablet-input {
  border: 0;
  margin-left: 100px;
}
.location {
  display: flex;
  align-items: flex-start;
}
.location ion-icon {
  color: #afc0d5;
  padding-top: 2px;
  padding-right: 0px;
}
.location span {
  font-size: 1rem;
  font-weight: bold;
  color: #212121;
  padding-left: 0px;
}
.doctor-info-appLogic h2 {
  display: inline;
  background-color: #3880ff;
  font-size: 1rem;
  color: white;
  padding: 5px 20px;
  border-radius: 10px;
  margin-bottom: 10px;
}
.reason ion-card {
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 10px 0;
}
.reason ion-card-header {
  font-size: 1.13rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
.reason ion-item {
  background: transparent;
  border-radius: 5px;
  margin: 5px 0;
  padding: 10px;
  border-bottom: none !important;
}
.reason ion-label {
  font-size: 1.13rem;
  font-weight: 600;
  color: #444;
  margin-bottom: 7px;
}
ion-select::part(icon) {
  color: #007aff;
  font-size: 1.13rem;
  margin-right: 8px;
}
.reason ion-checkbox {
  --background-checked: #3880ff;
  margin-left: 5px;
}
.reason a {
  color: #3880ff;
  text-decoration: none;
  font-weight: bold;
}
.reason a:hover {
  text-decoration: underline;
}
.reason p[danger] {
  color: red;
  font-size: 0.88rem;
  margin-top: 5px;
}
ion-card.reasonAdditionals {
  padding: 15px;
  background: #ffffff;
  border-radius: 10px;
}
.reasonAdditionals ion-card-header {
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.reasonAdditionals ion-item {
  background: transparent;
  border-radius: 5px;
  margin: 5px 0;
}
.reasonAdditionals ion-label {
  font-size: 1.13rem;
  font-weight: 600;
  color: #444;
}
.reasonAdditionals ion-textarea,
ion-input {
  background: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
  font-size: 0.88rem;
  width: 100%;
}
.reasonAdditionals ion-checkbox {
  --border-radius: 5px;
  --background-checked: #3880ff;
  margin-left: 5px;
}
.reasonAdditionals a {
  color: #3880ff;
  text-decoration: none;
  font-weight: bold;
}
.reasonAdditionals a:hover {
  text-decoration: underline;
}
.reasonAdditionals .requiredField p[danger] {
  color: red;
  font-size: 0.88rem;
  margin-top: 5px;
}
.contact-button {
  --background: #7acb46 !important;
  border-radius: 12px !important;
  font-size: 0.88rem;
  padding: 10px;
  font-weight: bold;
  cursor: pointer;
  --box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}
.success span {
  font-weight: 600;
}
.success ion-button:hover {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform: scale(1.05);
  box-shadow: 0px 4px 8px rgba(255, 255, 255, 0.2);
}
@media (max-width: 768px) {
  .success ion-col {
    width: 100%;
  }
  .success ion-card {
    padding: 10px;
    max-width: 90%;
    margin: 0 auto;
  }
  .success h2 {
    font-size: 1.25rem;
  }
  .success ion-button {
    margin-bottom: 0px;
  }
}
.patient-card ion-item ion-label {
  margin-bottom: 7px !important;
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
    margin: 0 auto;
  }
}
.noMargin {
  margin: 0 !important;
}
.fullSizeContentArea {
  min-height: calc(100% - 86px);
}
.hovercalendar {
  font-size: 1.88rem;
  color: red;
}
.multiline {
  white-space: pre-line;
}
.datecontrol {
  text-align: center;
  font-size: 1.4em;
}
#fullcalendar {
  display: inline-block;
}
.select-reason-popover {
  width: 90%;
  max-width: 550px;
}
.select-reason-popover .popover-content {
  width: 90%;
  max-width: 550px;
}
.noticeText {
  text-align: center;
}
.no-texttransform {
  text-transform: capitalize !important;
}
.align-left {
  float: left !important;
}
.no-left-pad {
  padding-left: 0px !important;
}
.request-modal-page textarea {
  max-width: 100%;
  width: 100%;
  height: 10vh;
}
.request-modal-page .selectable-item {
  cursor: pointer;
}
.request-modal-page .multiple-text {
  font-size: small;
}
.doc.has-refresher scroll-content {
  border: 0;
}
.doc .reason ion-select {
  max-width: initial;
}
.doc doc-info ion-card ion-grid {
  padding: 16px 16px 0 16px;
}
.doc doc-info ion-card ion-grid ion-card-content {
  padding: 0;
}
.doc doc-info ion-card ion-grid ion-card-content ion-row.action-row {
  margin-left: 16px;
}
.doc doc-info ion-card ion-grid ion-card-content ion-row ion-col.image {
  padding: 0 5px 0 0;
}
.doc doc-info ion-card ion-grid ion-card-content ion-row ion-col.info {
  padding: 0 0 0 5px;
}
.doc doc-info ion-card ion-grid ion-card-content ion-row ion-col.info .card-tel-btn {
  padding-left: 0;
  text-transform: lowercase !important;
}
.doc .calendar-wrapper {
  background: #fff;
}
.doc .calendar-wrapper calendar-controls {
  padding: 0 10px;
  display: block;
  background: #fff;
}
.doc .calendar-wrapper calendar-controls .controls .button-inner {
  font-size: 1.5rem;
}
.doc .calendar-wrapper calendar-controls .controls .date {
  font-size: 1.8rem;
  line-height: 5.3rem;
  white-space: nowrap;
}
.doc .calendar-wrapper calendar-content {
  display: block;
}
.doc .calendar-wrapper calendar-content ion-spinner {
  width: 100%;
  height: 50px;
  margin: 15px 0;
  display: block;
}
.doc .calendar-wrapper calendar-content .list-header-md {
  background-color: inherit;
}
.doc .calendar-wrapper calendar-content ion-grid ion-list-header .item-inner .input-wrapper ion-label {
  margin-bottom: 0px;
}
.doc .calendar-wrapper calendar-content ion-grid ion-row ion-col button {
  min-width: 70px;
}
.doc .calendar-wrapper calendar-content ion-grid ion-row ion-col button > .button-inner {
  -webkit-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
}
.doc .calendar-wrapper calendar-content ion-grid ion-row ion-col button .privat {
  width: 100%;
  max-width: 100%;
  font-size: 0.8em;
  margin: 0;
}
.calendar-content {
  padding-bottom: 50px;
}
.calendar-content .bs-row {
  position: relative;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  border-top: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  border-left: 1px solid #dedede;
}
.calendar-content .bs-row.week-wrapper {
  border: none;
}
.calendar-content .bs-row .no-apps {
  position: absolute;
  top: 50px;
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid #dedede;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 70%;
  margin: auto 15%;
}
.calendar-content .bs-row .no-apps p {
  font-weight: 300;
  text-align: center;
}
.calendar-content .bs-row .requestbutton {
  margin: 0 auto;
}
.calendar-content .bs-row .day-column {
  width: 14.28%;
  min-height: 300px;
  float: left;
  border-right: 1px solid #dedede;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.calendar-content .bs-row .day-column:nth-child(even) {
  background-color: #f4f4f4;
}
.calendar-content .bs-row .day-column .day {
  overflow: hidden;
  border-bottom: 1px solid #dedede;
  padding-bottom: 4px;
}
.calendar-content .bs-row .day-column .day span {
  white-space: nowrap;
}
.calendar-content .bs-row .day-column .day span.weekday {
  float: left;
  font-size: 1.25rem;
  font-weight: bold;
  margin: 7px 0 0 4px;
}
.calendar-content .bs-row .day-column .day span.date {
  float: right;
  margin: 12px 2px 0 0;
}
.calendar-content .bs-row .day-column .app {
  padding: 0px 2px;
}
.calendar-content .bs-row .day-column .app button {
  width: initial;
  min-width: 80px;
  margin: 0 auto;
  margin-bottom: 4px;
  margin-top: 4px;
}
.calendar-content .bs-row .day-column .app button > .button-inner {
  -webkit-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
}
.calendar-content .bs-row .day-column .app button .privat {
  width: 100%;
  max-width: 100%;
  font-size: 0.8em;
  margin: 0;
}
.calendar-content .bs-row .day-column .app button:hover {
  background-color: var(logogreen);
}
.platform-core .doc,
.platform-tablet .doc {
  background: white;
}
.platform-core .doc .infos,
.platform-tablet .doc .infos {
  margin-top: -100px;
  margin-bottom: 30px;
}
.platform-core .doc .hint,
.platform-tablet .doc .hint {
  margin-top: 20px;
  margin-bottom: 20px;
}
.platform-core .doc .hint h3,
.platform-tablet .doc .hint h3 {
  margin-bottom: 0;
}
.platform-core .doc .hint p,
.platform-tablet .doc .hint p {
  margin-bottom: 30px;
}
.platform-core .doc .calendar-wrapper,
.platform-tablet .doc .calendar-wrapper {
  box-shadow: var(card-md-box-shadow);
}
.platform-core .doc .calendar-wrapper calendar-controls .controls .button-inner,
.platform-tablet .doc .calendar-wrapper calendar-controls .controls .button-inner {
  font-size: 2rem;
}
.platform-core .doc .calendar-wrapper calendar-controls .controls .date,
.platform-tablet .doc .calendar-wrapper calendar-controls .controls .date {
  font-size: 2.5rem;
  line-height: 4.8rem;
  white-space: nowrap;
}
.last-visit {
  background: #e6ebf1;
  padding: 0px 0px 12px 7px;
  border-radius: 5px;
  display: flex;
  width: 95%;
}
.last-visit ion-item {
  display: flex;
  width: 100%;
  --background: #e6ebf1 !important;
}
.weblink {
  text-decoration: underline;
  cursor: pointer;
}
.image-container {
  width: 30%;
  aspect-ratio: 1/1;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
}
.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.overlay {
  position: relative;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.overlay-text {
  position: absolute;
  color: #3880ff;
  font-size: 1rem;
  font-weight: bold;
  background: white;
  padding: 6px 10px;
  border-radius: 45px;
}
.doctor-info {
  padding: 16px;
}
.doctitle {
  margin-top: 0;
  padding-top: 0;
}
.doctitle h2,
.doctitle h4,
.doctitle p {
  padding: 0;
  margin: 5px 0;
}
.doctitle p {
  font-weight: 600;
  color: #000000;
}
.doctor-info-appLogic {
  background: #e1ecff !important;
  background-color: #e1ecff !important;
  --ion-item-background:#e1ecff;
}
.doctor-title {
  font-size: 1.19rem !important;
  font-weight: bold;
  color: #3d3d3d;
}
.doctor-spec {
  font-size: 0.88rem !important;
  color: #101010;
}
.badge {
  background: #ffffff !important;
  padding: 2px 15px !important;
  border: 1px solid #adadad !important;
  border-radius: 20px !important;
  font-size: 0.75rem !important;
  font-weight: bold !important;
  color: #333;
}
.close-button {
  --background: #7acb46;
  border-radius: 12px !important;
  font-size: 0.88rem;
  font-weight: bold;
  cursor: pointer;
}
.book-button {
  --background: #7acb46;
  margin: 35px 0px 30px 0px;
  border-radius: 12px !important;
  font-size: 0.88rem;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  --box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}
.request-button {
  --background: #ffffff;
  margin: 35px 0px 30px 0px;
  border-radius: 12px !important;
  font-size: 0.88rem;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  color: #333;
  --box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}
.request-button:hover,
.request-button:focus {
  --background: #e1ecff;
}
.chain-app-button {
  margin-top: 15px;
}
.chain-book-button {
  --background: #7acb46;
  border-radius: 12px !important;
  margin-top: 15px;
  font-size: 0.88rem;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  --box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}
.chainBackground {
  background: #e1ecff;
  --background: #e1ecff;
}
.disableStep {
  opacity: 0.5;
  background: none;
}
.disableStep ion-card-content {
  border: solid 1px #3776E5;
  border-radius: 15px;
  color: #3776E5;
}
.disableStep ion-label {
  color: #3776E5;
}
.chain-button {
  --background: #7acb46;
  border-radius: 12px !important;
  font-size: 0.88rem;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  text-transform: uppercase;
  --box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}
.chain-button::part(native) {
  border-radius: 12px !important;
}
.chain-button ion-icon {
  font-size: 1.56rem;
}
.chain-book-button::part(native) {
  border-radius: 12px !important;
}
.chain-book-button ion-icon {
  font-size: 1.56rem;
}
.book-button::part(native) {
  border-radius: 12px !important;
}
.book-button ion-icon {
  font-size: 1.56rem;
}
.request-button::part(native) {
  border-radius: 12px !important;
}
.request-button ion-icon {
  font-size: 1.56rem;
}
.appButton {
  min-width: 75px;
}
.chain-reason {
  font-weight: 700;
  font-size: 1.0625rem;
  color: black;
}
.chain-reason span {
  color: #3776E5;
}
.tabs {
  display: flex;
  justify-content: space-around;
  padding: 12px;
  background: white;
}
.tabs ion-label {
  font-size: 0.88rem;
  font-weight: bold;
  cursor: pointer;
  color: #7f9abb;
  position: relative;
  padding-bottom: 10px;
}
.tabs .active ion-label {
  color: #3880ff !important;
}
.opening-hours {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin-bottom: 12px;
  margin-top: 20px m !important;
}
.opening-hours-headline {
  color: #8fa7c4;
}
.opening-hours ion-label {
  width: 100%;
  font-size: 0.88rem;
  font-weight: bold;
}
.tab-list {
  margin-top: 20px;
}
.tab-list ion-label {
  color: #000000;
  font-size: 1rem;
  font-weight: 500;
}
.tab-list ion-icon {
  color: #000000;
  font-size: 1.25rem;
}
.welcomeCard h2 {
  font-size: 1.25rem;
  color: #000000;
  font-weight: bold;
}
.welcomeCard p {
  font-size: 1rem !important;
  color: #000000;
}
.itemQue {
  margin-bottom: 20px;
}
ion-item.itemList ion-button {
  --background: #e1ecff !important;
  color: #000000;
  font-weight: bold;
  width: 100%;
  white-space: normal;
}
ion-item.itemList span {
  padding: 10px 10px;
}
.location {
  display: flex;
  align-items: flex-start;
}
.location ion-icon {
  color: #afc0d5;
  padding-top: 2px;
  padding-right: 0px;
}
.location span {
  font-size: 1rem;
  color: #212121;
  padding-left: 0px;
}
.custom-text {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  padding: 0px 35px;
  border-radius: 8px;
  margin: 8px 0;
  display: block;
  text-align: justify;
  line-height: 1.5;
}
.overlay {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  opacity: 0.6;
  position: relative;
}
.overlay-text {
  position: absolute;
  color: #3880ff;
  font-size: 1rem;
  font-weight: bold;
  background: white;
  padding: 6px 10px;
  border-radius: 45px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .doctor-info ion-row {
    flex-wrap: nowrap !important;
  }
  .doctor-info ion-card-header {
    display: block;
  }
  .info {
    flex-direction: column !important;
  }
  .doctor-title {
    order: 1 !important;
    font-size: 1rem !important;
    padding-bottom: 5px;
  }
  .doctor-spec {
    order: 2 !important;
    font-size: 0.75rem !important;
  }
  .tabs {
    display: flex;
    justify-content: none;
    padding: 12px;
  }
}
.deactivated-appointment {
  text-align: center;
  font-size: 1rem;
  color: #ff0000;
  margin-top: -15px;
  margin-bottom: 15px;
}
.messageHeadline {
  font-size: 1rem !important;
}
.messages .datemobile {
  font-size: 0.88rem;
  color: #aaaaaa;
  text-align: right;
}
.messages .namemobile {
  font-size: 0.88rem;
  font-weight: 700;
  text-align: left;
}
.messages ion-list button.unread {
  background-color: #e9f1f3;
}
.messages ion-list button ion-col {
  padding: 0px;
}
.messages ion-list button h2,
.messages ion-list button h3,
.messages ion-list button p,
.messages ion-list button .label div {
  white-space: normal;
}
.messages ion-list .date {
  text-align: right;
  white-space: nowrap;
}
.messages ion-list .message {
  margin-top: 7px;
}
.messages ion-list .inline {
  display: inline;
}
.messages .message ion-card {
  padding: 10px;
}
.messages .message ion-avatar {
  margin: 0;
}
.messages .message ion-avatar img {
  width: 70px;
  height: 70px;
}
.messages .message .message {
  margin-top: 7px;
}
.marginapp {
  margin: 35px;
  width: 100%;
}
.loginpage {
}
.loginpage .primary-button {
  background-color: var(--accent-color);
  color: var(--button-hover);
}
.loginpage .primary-button:hover {
  background-color: --button-hover;
}
.loginpage .primary-button:active {
  background-color: --button-active;
}
.loginpage .primary-button.disabled {
  background-color: --button-inaktiv;
}
.loginpage .secondary-button {
  background-color: --secondary-button-normal;
}
.loginpage .secondary-button:hover {
  background-color: --secondary-button-hover;
}
.loginpage .secondary-button:active {
  background-color: --secondary-button-active;
}
.loginpage .secondary-button.disabled {
  background-color: --secondary-button-inaktiv;
}
.loginpage :root {
  --primary-color: #003f78;
  --secondary-color: #368b2b;
  --accent-color: #7acb48;
  --light-color: #f2f5f8;
  --dark-color: #666;
  --grid-columns: 12;
  --grid-gutter-width: 20px;
  --container-max-width: 1200px;
  --termed-blau: #003578;
  --termed-blau2: #79abbb;
  --termed-blau3: #0496c8;
  --termed-hellblau: #93deea;
  --termed-gruen: #7acb48;
  --termed-weiss: #ffffff;
  --termed-hellgrau: #f2f5f8;
  --termed-grau: #e0ebf1;
  --termed-verlauf-dunkelblau:
    linear-gradient(
      90deg,
      #0496c8,
      #003578);
  --termed-verlauf-hellblau:
    linear-gradient(
      90deg,
      #93deea,
      #0496c8);
  --termed-verlauf-gruen:
    linear-gradient(
      90deg,
      #93deea,
      #7acb48,
      #25aa8c);
  --termed-erfolg: #7acb48;
  --termed-information: #0496c8;
  --termed-warnung: #f5a823;
  --termed-gefahr: #d0021b;
  --button-normal: #7acb48;
  --button-hover: #fff;
  --button-active: #0496c8;
  --button-inaktiv: #c4d0d9;
  --secondary-button-normal: #ffffff;
  --secondary-button-hover: #fff;
  --secondary-button-active: #e0ebf1;
  --secondary-button-inaktiv: #c4d0d9;
}
.loginpage h1 {
  font-size: 4rem;
  font-family: "Kanit-SemiBold" !important;
  font-weight: bold;
}
.loginpage h2 {
  font-size: 3.45rem;
  font-family: "Kanit-SemiBold" !important;
  font-weight: bold;
}
.loginpage h3 {
  font-size: 2.2rem;
  font-family: "Kanit-SemiBold" !important;
  font-weight: bold;
}
.loginpage p {
  font-size: 1rem;
  font-family: "Kanit-ExtraLight" !important;
}
.loginpage p.alt {
  font-size: 0.88rem;
  font-family: "Kanit-ExtraLight" !important;
}
.loginpage h1,
.loginpage h2,
.loginpage h3,
.loginpage h4,
.loginpage h5,
.loginpage h6,
.loginpage p {
  color: var(--primary-color);
}
.loginpage ion-header ion-title {
  font-weight: bold;
}
.loginpage ion-header ion-button {
  margin-right: 10px;
}
.loginpage .hero-section {
  background-color: var(--termed-hellgrau);
  padding: 60px 20px;
}
.loginpage .hero-section .hero-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.loginpage .hero-section .hero-content .hero-text {
  max-width: 50%;
}
.loginpage .hero-section .hero-content .hero-text h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}
.loginpage .hero-section .hero-content .hero-text form {
  display: flex;
  flex-direction: column;
}
.loginpage .hero-section .hero-content .hero-text form .input-card {
  background: var(--termed-weiss);
  padding: 26px 20px;
  border-radius: 12px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.loginpage .hero-section .hero-content .hero-text form .form-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.loginpage .hero-section .hero-content .hero-text form .form-options ion-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
  --padding-start: 0;
  border-radius: 10px;
}
.loginpage .hero-section .hero-content .hero-text form .form-options ion-label {
  color: #003578;
}
.loginpage .hero-section .hero-content .hero-text form .form-options a {
  font-size: 0.9rem;
  color: #2c7ebf;
  text-decoration: none;
}
.loginpage .hero-section .hero-content .hero-text form ion-button {
  margin-top: 10px;
}
.loginpage .hero-section .hero-content .hero-image {
  max-width: 40%;
}
.loginpage .hero-section .hero-content .hero-image img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}
@media (max-width: 768px) {
  .loginpage .hero-section .hero-content {
    flex-direction: column;
    text-align: center;
  }
  .loginpage .hero-section .hero-content .hero-text,
  .loginpage .hero-section .hero-content .hero-image {
    max-width: 100%;
  }
  .loginpage .hero-section .hero-content .hero-image {
    margin-top: 30px;
  }
  .loginpage .hero-section .form-options {
    flex-direction: column;
    align-items: flex-start;
  }
  .loginpage .hero-section .form-options a {
    margin-top: 10px;
  }
}
.loginpage .faq {
  padding: 40px 0;
  text-align: center;
}
.loginpage .faq .container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.loginpage .faq h2 {
  font-size: 2rem;
  margin-bottom: 40px;
  color: #003f78;
}
.loginpage .partners {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  text-align: center;
}
.loginpage .partner-img {
  margin: 0 auto;
  max-width: 150%;
}
.loginpage .partners .partner-images {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.loginpage .partners h2 {
  margin-bottom: 20px;
}
.loginpage .partners p {
  margin: 0 auto;
  max-width: 600px;
  line-height: 1.6;
}
.loginpage .partners p span {
  display: block;
  margin-bottom: 10px;
}
.loginpage .social-icons {
  display: flex;
  gap: 10px;
}
.loginpage .social-icons ion-img {
  width: 24px;
  height: 24px;
}
.loginpage .buttons {
  margin-top: 10px;
}
.loginpage .buttons ion-button {
  --background: #e0e0e0;
  --color: var(--termed-blau);
  margin-right: 10px;
}
.loginpage .buttons ion-button ion-img {
  width: 20px;
  height: auto;
  margin-right: 5px;
}
.loginpage .legal-links {
  list-style-type: none;
  display: flex;
  gap: 15px;
  padding: 0;
}
.loginpage .legal-links li a {
  text-decoration: none;
  color: #003578;
}
.loginpage .legal-links li a:hover {
  text-decoration: underline;
}
.loginpage .circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.loginpage .circle.black {
  background-color: #000000;
}
.loginpage .circle.red {
  background-color: #FF0000;
}
.loginpage .circle.gold {
  background-color: #FFCC00;
}
h1 {
  font-size: inherit;
  margin: 0;
}
img {
  color: #ffffff;
}
input {
  background: #ffffff;
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
.no-padding-left {
  padding-left: 0 !important;
}
.no-padding-right {
  padding-right: 0 !important;
}
.ion-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.center-vertical {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.font-small {
  font-size: 1.5rem !important;
}
.font-big {
  font-size: 1.9rem !important;
}
.font-bigger {
  font-size: 2.1rem !important;
}
.font-normal {
  font-weight: normal;
}
.font-bold {
  font-weight: 500;
}
.font-bolder {
  font-weight: 700 !important;
}
.margin-bottom {
  margin-bottom: 5px;
}
ion-card p {
  margin: 0;
  line-height: normal;
}
#date {
  width: 316px;
  margin: auto;
}
.align-right {
  float: right;
}
.full-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
p[text-wrap] {
  white-space: normal;
}
.footernav .item-md.item-block .item-inner {
  border-bottom: none;
}
.footernav .item-md {
  background: inherit;
  padding: 0;
}
.navli {
  float: left;
}
a.navli {
  margin: 5px 0;
  padding: 5px 10px;
  text-decoration: none;
}
a.navli:hover {
  color: #0496c8;
}
.patient-footer {
  background: #00b6e8;
  color: #ffffff;
  height: auto;
  -webkit-box-shadow: -1px -4px 10px -5px #000000;
  box-shadow: -1px -4px 10px -5px #000000;
}
.shortnav {
  display: flex;
  width: 100%;
}
.pfele {
  width: 25%;
  padding: 5px 2.5%;
  border-right: solid 1px #eeeeee;
}
.pfeleico {
  font-size: 1.88rem;
  text-align: center;
  width: 100%;
  position: relative;
  display: block;
  color: #ffffff;
}
.pfeletxt {
  font-size: 0.62rem;
  text-align: center;
}
a.pfele .pfeletxt {
  color: #ffffff;
  text-decoration: none !important;
}
.spacer {
  height: 50px;
}
.version {
  clear: both;
  display: block;
  position: relative;
  float: none;
  width: 100%;
}
.favmsg {
  color: #00b6e8 !important;
}
.cookie .cookie-law .cookie-law-wrapper {
  max-width: 500px !important;
  font-size: 1rem !important;
  background-color: rgba(51, 51, 51, 0.81) !important;
}
@media (min-width: 768px) {
  .cookie .cookie-law .cookie-law-wrapper {
    bottom: 10px !important;
    left: 10px !important;
  }
}
.footer-bottom-toolbar {
  background: #f2f5f8;
  padding: 10px 20px;
  text-align: center;
}
.footer-bottom-toolbar p {
  font-weight: bold;
  color: var(--termed-blau2);
}
.footer-bottom-toolbar a {
  font-weight: bold;
  color: var(--termed-blau2);
}
@media only screen and (max-width: 768px) {
  .footer-bottom-toolbar {
    text-align: left;
  }
}
.startheader {
  background: #fff;
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  color: var(--primary-color);
}
.headerbuttons {
  float: right;
}
.login-buttons ion-img {
  width: 20px;
  height: auto;
  margin-right: 5px;
}
.praxis-btn {
  color: #003f78 !important;
}
.patient-btn {
  background-color: #368b2b;
  color: #003f78 !important;
}
.container {
  justify-content: center;
  width: 1200px;
  width: 90%;
  margin: 0 auto;
  max-width: var(--container-max-width);
}
ion-header {
  background: var(--primary-color);
  color: #003f78;
  min-height: 45px;
  width: 100%;
}
.header-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
ion-img.menu-logo {
  min-width: 150px;
  width: 150px;
  margin-top: -10px;
}
.logo ion-img {
  min-width: 150px;
  width: 150px;
  margin-top: -10px;
}
@media only screen and (max-width: 768px) {
  .logo ion-img {
    min-width: 120px !important;
    max-width: auto;
    width: 120px;
    position: absolute;
    right: 0px;
  }
}
.menutoolbar {
  background: #fff;
}
.starttoolbar {
  padding: 5px;
}
.menu-button {
  color: var(--primary-color);
  float: left;
}
.topnav {
  color: #003578;
}
.topnav .itemtop {
  border-radius: 10px;
}
.logo {
  height: 60px;
}
@media only screen and (max-width: 768px) {
  .logo {
    height: auto;
  }
}
.logo .separate-top {
  border-top: 1px solid #cecece !important;
}
.logo .hidden {
  display: none !important;
}
.logo ion-header {
  color: #cecece !important;
}
.logo ion-header:after {
  background-image: none;
}
.logo ion-header ion-toolbar .toolbar-background {
  border: none;
  background-color: #313131;
}
.logo ion-header ion-toolbar .toolbar-content img {
  max-height: 70px;
  padding: 10px 0 5px 10px;
}
.logo ion-header ion-toolbar .toolbar-content .user-info {
  overflow: hidden;
  text-align: right;
  padding-top: 14px;
  white-space: normal;
}
.logo ion-header ion-toolbar .toolbar-content .user-info .name {
  font-size: 1.5rem;
}
.logo ion-header ion-toolbar .toolbar-content .user-info .email {
  font-size: 1.3rem;
}
.logo ion-content {
  background-color: #313131;
}
.logo ion-content .scroll-content {
  overflow-y: auto;
}
.logo ion-content ion-list ion-item {
  background-color: #313131;
}
.logo ion-content ion-list .item {
  background-color: #313131;
}
.logo ion-content ion-list .list-md {
  background-color: #313131;
}
.logo ion-content ion-list ion-label,
.logo ion-content ion-list ion-icon {
  color: #cecece !important;
}
.logo ion-content ion-list .user-info-desktop {
  bottom: 0;
  position: fixed;
}
.logo a:hover {
  opacity: 1;
}
.logo a:hover a,
.logo a:hover ion-label,
.logo a:hover ion-icon {
  color: #f4f4f4 !important;
}
.logo .navli {
  float: left;
}
.logo a.navli {
  color: #cecece;
  margin: 5px 0;
  padding: 5px 10px;
  text-decoration: none;
}
.logo a.navli:hover {
  color: #ffffff;
}
.legal-texts ol {
  list-style-type: none;
  counter-reset: item;
  margin: 0;
  padding: 0;
}
.legal-texts ol > li {
  display: table;
  counter-increment: item;
  margin-bottom: 0.6em;
}
.legal-texts ol > li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
  padding-right: 0.6em;
}
.legal-texts li ol > li {
  margin: 0;
}
.legal-texts li ol > li:before {
  content: counters(item, ".") " ";
}
.ios .ion-ios-search-outline:before {
  content: "\f4a5";
}
.ios .ion-ios-settings-outline:before {
  content: "\f4a7";
}
.ios ion-content {
  background-color: #f7f7f8;
}
.ios ion-list-header {
  border-bottom-color: #cecece;
}
.ios ion-card {
  margin: 0 0 12px 0;
  width: 100%;
  box-shadow: none;
  border-bottom: 1px solid #cecece;
}
.ios scroll-content {
  overflow-y: auto;
}
.ios ion-header ion-toolbar ion-segment .segment-button.segment-activated {
  border-color: #00b6e8 !important;
}
.md ion-list-header {
  border: none;
}
.platform-core {
  user-select: initial;
  -webkit-user-select: initial;
  -moz-user-select: initial;
  user-select: initial;
}
.ion-card .image {
  height: 0;
}
.md,
.platform-core,
.platform-tablet {
}
.md .ion-page ion-content .scroll-content,
.md .ion-page .content .scroll-content,
.platform-core .ion-page ion-content .scroll-content,
.platform-core .ion-page .content .scroll-content,
.platform-tablet .ion-page ion-content .scroll-content,
.platform-tablet .ion-page .content .scroll-content {
  background-color: #eeeeee;
}
.md .ion-page .list-header,
.platform-core .ion-page .list-header,
.platform-tablet .ion-page .list-header {
  background-color: #eeeeee;
}
.md ion-list-header,
.md ion-item-divider,
.md .list-header,
.platform-core ion-list-header,
.platform-core ion-item-divider,
.platform-core .list-header,
.platform-tablet ion-list-header,
.platform-tablet ion-item-divider,
.platform-tablet .list-header {
  border-bottom: none;
}
.md .ion-width,
.platform-core .ion-width,
.platform-tablet .ion-width {
  width: calc(100% - 20px);
}
.md .ion-md-arrow-back:before,
.platform-core .ion-md-arrow-back:before,
.platform-tablet .ion-md-arrow-back:before {
  content: "\f3cf";
}
.md .ion-md-arrow-forward:before,
.platform-core .ion-md-arrow-forward:before,
.platform-tablet .ion-md-arrow-forward:before {
  content: "\f3d1";
}
.md .ion-md-arrow-down:before,
.platform-core .ion-md-arrow-down:before,
.platform-tablet .ion-md-arrow-down:before {
  content: "\f3d0";
}
.md .button-clear,
.platform-core .button-clear,
.platform-tablet .button-clear {
  color: #232323;
}
.md .margin-top,
.platform-core .margin-top,
.platform-tablet .margin-top {
  margin-top: 12px;
}
.md .login .item-input.ng-valid.input-has-value:not(.input-has-focus) .item-inner,
.platform-core .login .item-input.ng-valid.input-has-value:not(.input-has-focus) .item-inner,
.platform-tablet .login .item-input.ng-valid.input-has-value:not(.input-has-focus) .item-inner {
  border-bottom-color: inherit;
  box-shadow: inherit;
}
.md h1[danger],
.md h2[danger],
.md h3[danger],
.md h4[danger],
.md h5[danger],
.md h6[danger],
.md p[danger],
.md span[danger],
.md a:not([button])[danger],
.md small[danger],
.md b[danger],
.md i[danger],
.md strong[danger],
.md em[danger],
.md sub[danger],
.md sup[danger],
.md ion-icon[danger],
.platform-core h1[danger],
.platform-core h2[danger],
.platform-core h3[danger],
.platform-core h4[danger],
.platform-core h5[danger],
.platform-core h6[danger],
.platform-core p[danger],
.platform-core span[danger],
.platform-core a:not([button])[danger],
.platform-core small[danger],
.platform-core b[danger],
.platform-core i[danger],
.platform-core strong[danger],
.platform-core em[danger],
.platform-core sub[danger],
.platform-core sup[danger],
.platform-core ion-icon[danger],
.platform-tablet h1[danger],
.platform-tablet h2[danger],
.platform-tablet h3[danger],
.platform-tablet h4[danger],
.platform-tablet h5[danger],
.platform-tablet h6[danger],
.platform-tablet p[danger],
.platform-tablet span[danger],
.platform-tablet a:not([button])[danger],
.platform-tablet small[danger],
.platform-tablet b[danger],
.platform-tablet i[danger],
.platform-tablet strong[danger],
.platform-tablet em[danger],
.platform-tablet sub[danger],
.platform-tablet sup[danger],
.platform-tablet ion-icon[danger] {
  color: #f53d3d;
}
.md ion-item[no-margin],
.platform-core ion-item[no-margin],
.platform-tablet ion-item[no-margin] {
  min-height: 1rem;
}
.md ion-item[no-margin] .item-inner,
.platform-core ion-item[no-margin] .item-inner,
.platform-tablet ion-item[no-margin] .item-inner {
  border-bottom: none;
}
.md ion-item[no-margin] ion-label,
.platform-core ion-item[no-margin] ion-label,
.platform-tablet ion-item[no-margin] ion-label {
  margin-top: 0px;
  margin-bottom: 0px;
}
.md ion-header ion-toolbar ion-segment .segment-button,
.md ion-header ion-toolbar .segment .segment-button,
.platform-core ion-header ion-toolbar ion-segment .segment-button,
.platform-core ion-header ion-toolbar .segment .segment-button,
.platform-tablet ion-header ion-toolbar ion-segment .segment-button,
.platform-tablet ion-header ion-toolbar .segment .segment-button {
  border-bottom-color: transparent;
  color: #fff;
}
.md ion-header ion-toolbar ion-segment .segment-button.segment-activated,
.md ion-header ion-toolbar .segment .segment-button.segment-activated,
.platform-core ion-header ion-toolbar ion-segment .segment-button.segment-activated,
.platform-core ion-header ion-toolbar .segment .segment-button.segment-activated,
.platform-tablet ion-header ion-toolbar ion-segment .segment-button.segment-activated,
.platform-tablet ion-header ion-toolbar .segment .segment-button.segment-activated {
  border-color: #fff;
}
.menu-header {
  min-height: 80px;
}
.subMenuContainer {
  padding-left: 15px;
}
.menu-footer p {
  color: #cecece;
  padding-left: 10px;
}
.platform-core,
.platform-tablet {
  right: 0;
}
.platform-core .container,
.platform-tablet .container {
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.platform-core .container::after,
.platform-tablet .container::after {
  content: "";
  display: table;
  clear: both;
}
@media (min-width: 544px) {
  .platform-core .container,
  .platform-tablet .container {
    max-width: 576px;
  }
}
@media (min-width: 768px) {
  .platform-core .container,
  .platform-tablet .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .platform-core .container,
  .platform-tablet .container {
    max-width: 940px;
  }
}
@media (min-width: 1200px) {
  .platform-core .container,
  .platform-tablet .container {
    max-width: 1140px;
  }
}
.platform-core .container-fluid,
.platform-tablet .container-fluid {
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.platform-core .container-fluid::after,
.platform-tablet .container-fluid::after {
  content: "";
  display: table;
  clear: both;
}
.platform-core .bs-row,
.platform-tablet .bs-row {
  margin-left: -15px;
  margin-right: -15px;
}
.platform-core .bs-row::after,
.platform-tablet .bs-row::after {
  content: "";
  display: table;
  clear: both;
}
.platform-core .col-xs-1,
.platform-tablet .col-xs-1 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 8.33333%;
}
.platform-core .col-xs-2,
.platform-tablet .col-xs-2 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 16.66667%;
}
.platform-core .col-xs-3,
.platform-tablet .col-xs-3 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 25%;
}
.platform-core .col-xs-4,
.platform-tablet .col-xs-4 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 33.33333%;
}
.platform-core .col-xs-5,
.platform-tablet .col-xs-5 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 41.66667%;
}
.platform-core .col-xs-6,
.platform-tablet .col-xs-6 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 50%;
}
.platform-core .col-xs-7,
.platform-tablet .col-xs-7 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 58.33333%;
}
.platform-core .col-xs-8,
.platform-tablet .col-xs-8 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 66.66667%;
}
.platform-core .col-xs-9,
.platform-tablet .col-xs-9 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 75%;
}
.platform-core .col-xs-10,
.platform-tablet .col-xs-10 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 83.33333%;
}
.platform-core .col-xs-11,
.platform-tablet .col-xs-11 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 91.66667%;
}
.platform-core .col-xs-12,
.platform-tablet .col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 100%;
}
.platform-core .pull-xs-0,
.platform-tablet .pull-xs-0 {
  right: auto;
}
.platform-core .pull-xs-1,
.platform-tablet .pull-xs-1 {
  right: 8.33333%;
}
.platform-core .pull-xs-2,
.platform-tablet .pull-xs-2 {
  right: 16.66667%;
}
.platform-core .pull-xs-3,
.platform-tablet .pull-xs-3 {
  right: 25%;
}
.platform-core .pull-xs-4,
.platform-tablet .pull-xs-4 {
  right: 33.33333%;
}
.platform-core .pull-xs-5,
.platform-tablet .pull-xs-5 {
  right: 41.66667%;
}
.platform-core .pull-xs-6,
.platform-tablet .pull-xs-6 {
  right: 50%;
}
.platform-core .pull-xs-7,
.platform-tablet .pull-xs-7 {
  right: 58.33333%;
}
.platform-core .pull-xs-8,
.platform-tablet .pull-xs-8 {
  right: 66.66667%;
}
.platform-core .pull-xs-9,
.platform-tablet .pull-xs-9 {
  right: 75%;
}
.platform-core .pull-xs-10,
.platform-tablet .pull-xs-10 {
  right: 83.33333%;
}
.platform-core .pull-xs-11,
.platform-tablet .pull-xs-11 {
  right: 91.66667%;
}
.platform-core .pull-xs-12,
.platform-tablet .pull-xs-12 {
  right: 100%;
}
.platform-core .push-xs-0,
.platform-tablet .push-xs-0 {
  left: auto;
}
.platform-core .push-xs-1,
.platform-tablet .push-xs-1 {
  left: 8.33333%;
}
.platform-core .push-xs-2,
.platform-tablet .push-xs-2 {
  left: 16.66667%;
}
.platform-core .push-xs-3,
.platform-tablet .push-xs-3 {
  left: 25%;
}
.platform-core .push-xs-4,
.platform-tablet .push-xs-4 {
  left: 33.33333%;
}
.platform-core .push-xs-5,
.platform-tablet .push-xs-5 {
  left: 41.66667%;
}
.platform-core .push-xs-6,
.platform-tablet .push-xs-6 {
  left: 50%;
}
.platform-core .push-xs-7,
.platform-tablet .push-xs-7 {
  left: 58.33333%;
}
.platform-core .push-xs-8,
.platform-tablet .push-xs-8 {
  left: 66.66667%;
}
.platform-core .push-xs-9,
.platform-tablet .push-xs-9 {
  left: 75%;
}
.platform-core .push-xs-10,
.platform-tablet .push-xs-10 {
  left: 83.33333%;
}
.platform-core .push-xs-11,
.platform-tablet .push-xs-11 {
  left: 91.66667%;
}
.platform-core .push-xs-12,
.platform-tablet .push-xs-12 {
  left: 100%;
}
.platform-core .offset-xs-1,
.platform-tablet .offset-xs-1 {
  margin-left: 8.33333%;
}
.platform-core .offset-xs-2,
.platform-tablet .offset-xs-2 {
  margin-left: 16.66667%;
}
.platform-core .offset-xs-3,
.platform-tablet .offset-xs-3 {
  margin-left: 25%;
}
.platform-core .offset-xs-4,
.platform-tablet .offset-xs-4 {
  margin-left: 33.33333%;
}
.platform-core .offset-xs-5,
.platform-tablet .offset-xs-5 {
  margin-left: 41.66667%;
}
.platform-core .offset-xs-6,
.platform-tablet .offset-xs-6 {
  margin-left: 50%;
}
.platform-core .offset-xs-7,
.platform-tablet .offset-xs-7 {
  margin-left: 58.33333%;
}
.platform-core .offset-xs-8,
.platform-tablet .offset-xs-8 {
  margin-left: 66.66667%;
}
.platform-core .offset-xs-9,
.platform-tablet .offset-xs-9 {
  margin-left: 75%;
}
.platform-core .offset-xs-10,
.platform-tablet .offset-xs-10 {
  margin-left: 83.33333%;
}
.platform-core .offset-xs-11,
.platform-tablet .offset-xs-11 {
  margin-left: 91.66667%;
}
@media (min-width: 544px) {
  .platform-core .col-sm-1,
  .platform-tablet .col-sm-1 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 8.33333%;
  }
  .platform-core .col-sm-2,
  .platform-tablet .col-sm-2 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 16.66667%;
  }
  .platform-core .col-sm-3,
  .platform-tablet .col-sm-3 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 25%;
  }
  .platform-core .col-sm-4,
  .platform-tablet .col-sm-4 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 33.33333%;
  }
  .platform-core .col-sm-5,
  .platform-tablet .col-sm-5 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 41.66667%;
  }
  .platform-core .col-sm-6,
  .platform-tablet .col-sm-6 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 50%;
  }
  .platform-core .col-sm-7,
  .platform-tablet .col-sm-7 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 58.33333%;
  }
  .platform-core .col-sm-8,
  .platform-tablet .col-sm-8 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 66.66667%;
  }
  .platform-core .col-sm-9,
  .platform-tablet .col-sm-9 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 75%;
  }
  .platform-core .col-sm-10,
  .platform-tablet .col-sm-10 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 83.33333%;
  }
  .platform-core .col-sm-11,
  .platform-tablet .col-sm-11 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 91.66667%;
  }
  .platform-core .col-sm-12,
  .platform-tablet .col-sm-12 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 100%;
  }
  .platform-core .pull-sm-0,
  .platform-tablet .pull-sm-0 {
    right: auto;
  }
  .platform-core .pull-sm-1,
  .platform-tablet .pull-sm-1 {
    right: 8.33333%;
  }
  .platform-core .pull-sm-2,
  .platform-tablet .pull-sm-2 {
    right: 16.66667%;
  }
  .platform-core .pull-sm-3,
  .platform-tablet .pull-sm-3 {
    right: 25%;
  }
  .platform-core .pull-sm-4,
  .platform-tablet .pull-sm-4 {
    right: 33.33333%;
  }
  .platform-core .pull-sm-5,
  .platform-tablet .pull-sm-5 {
    right: 41.66667%;
  }
  .platform-core .pull-sm-6,
  .platform-tablet .pull-sm-6 {
    right: 50%;
  }
  .platform-core .pull-sm-7,
  .platform-tablet .pull-sm-7 {
    right: 58.33333%;
  }
  .platform-core .pull-sm-8,
  .platform-tablet .pull-sm-8 {
    right: 66.66667%;
  }
  .platform-core .pull-sm-9,
  .platform-tablet .pull-sm-9 {
    right: 75%;
  }
  .platform-core .pull-sm-10,
  .platform-tablet .pull-sm-10 {
    right: 83.33333%;
  }
  .platform-core .pull-sm-11,
  .platform-tablet .pull-sm-11 {
    right: 91.66667%;
  }
  .platform-core .pull-sm-12,
  .platform-tablet .pull-sm-12 {
    right: 100%;
  }
  .platform-core .push-sm-0,
  .platform-tablet .push-sm-0 {
    left: auto;
  }
  .platform-core .push-sm-1,
  .platform-tablet .push-sm-1 {
    left: 8.33333%;
  }
  .platform-core .push-sm-2,
  .platform-tablet .push-sm-2 {
    left: 16.66667%;
  }
  .platform-core .push-sm-3,
  .platform-tablet .push-sm-3 {
    left: 25%;
  }
  .platform-core .push-sm-4,
  .platform-tablet .push-sm-4 {
    left: 33.33333%;
  }
  .platform-core .push-sm-5,
  .platform-tablet .push-sm-5 {
    left: 41.66667%;
  }
  .platform-core .push-sm-6,
  .platform-tablet .push-sm-6 {
    left: 50%;
  }
  .platform-core .push-sm-7,
  .platform-tablet .push-sm-7 {
    left: 58.33333%;
  }
  .platform-core .push-sm-8,
  .platform-tablet .push-sm-8 {
    left: 66.66667%;
  }
  .platform-core .push-sm-9,
  .platform-tablet .push-sm-9 {
    left: 75%;
  }
  .platform-core .push-sm-10,
  .platform-tablet .push-sm-10 {
    left: 83.33333%;
  }
  .platform-core .push-sm-11,
  .platform-tablet .push-sm-11 {
    left: 91.66667%;
  }
  .platform-core .push-sm-12,
  .platform-tablet .push-sm-12 {
    left: 100%;
  }
  .platform-core .offset-sm-0,
  .platform-tablet .offset-sm-0 {
    margin-left: 0%;
  }
  .platform-core .offset-sm-1,
  .platform-tablet .offset-sm-1 {
    margin-left: 8.33333%;
  }
  .platform-core .offset-sm-2,
  .platform-tablet .offset-sm-2 {
    margin-left: 16.66667%;
  }
  .platform-core .offset-sm-3,
  .platform-tablet .offset-sm-3 {
    margin-left: 25%;
  }
  .platform-core .offset-sm-4,
  .platform-tablet .offset-sm-4 {
    margin-left: 33.33333%;
  }
  .platform-core .offset-sm-5,
  .platform-tablet .offset-sm-5 {
    margin-left: 41.66667%;
  }
  .platform-core .offset-sm-6,
  .platform-tablet .offset-sm-6 {
    margin-left: 50%;
  }
  .platform-core .offset-sm-7,
  .platform-tablet .offset-sm-7 {
    margin-left: 58.33333%;
  }
  .platform-core .offset-sm-8,
  .platform-tablet .offset-sm-8 {
    margin-left: 66.66667%;
  }
  .platform-core .offset-sm-9,
  .platform-tablet .offset-sm-9 {
    margin-left: 75%;
  }
  .platform-core .offset-sm-10,
  .platform-tablet .offset-sm-10 {
    margin-left: 83.33333%;
  }
  .platform-core .offset-sm-11,
  .platform-tablet .offset-sm-11 {
    margin-left: 91.66667%;
  }
}
@media (min-width: 768px) {
  .platform-core .col-md-1,
  .platform-tablet .col-md-1 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 8.33333%;
  }
  .platform-core .col-md-2,
  .platform-tablet .col-md-2 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 16.66667%;
  }
  .platform-core .col-md-3,
  .platform-tablet .col-md-3 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 25%;
  }
  .platform-core .col-md-4,
  .platform-tablet .col-md-4 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 33.33333%;
  }
  .platform-core .col-md-5,
  .platform-tablet .col-md-5 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 41.66667%;
  }
  .platform-core .col-md-6,
  .platform-tablet .col-md-6 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 50%;
  }
  .platform-core .col-md-7,
  .platform-tablet .col-md-7 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 58.33333%;
  }
  .platform-core .col-md-8,
  .platform-tablet .col-md-8 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 66.66667%;
  }
  .platform-core .col-md-9,
  .platform-tablet .col-md-9 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 75%;
  }
  .platform-core .col-md-10,
  .platform-tablet .col-md-10 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 83.33333%;
  }
  .platform-core .col-md-11,
  .platform-tablet .col-md-11 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 91.66667%;
  }
  .platform-core .col-md-12,
  .platform-tablet .col-md-12 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 100%;
  }
  .platform-core .pull-md-0,
  .platform-tablet .pull-md-0 {
    right: auto;
  }
  .platform-core .pull-md-1,
  .platform-tablet .pull-md-1 {
    right: 8.33333%;
  }
  .platform-core .pull-md-2,
  .platform-tablet .pull-md-2 {
    right: 16.66667%;
  }
  .platform-core .pull-md-3,
  .platform-tablet .pull-md-3 {
    right: 25%;
  }
  .platform-core .pull-md-4,
  .platform-tablet .pull-md-4 {
    right: 33.33333%;
  }
  .platform-core .pull-md-5,
  .platform-tablet .pull-md-5 {
    right: 41.66667%;
  }
  .platform-core .pull-md-6,
  .platform-tablet .pull-md-6 {
    right: 50%;
  }
  .platform-core .pull-md-7,
  .platform-tablet .pull-md-7 {
    right: 58.33333%;
  }
  .platform-core .pull-md-8,
  .platform-tablet .pull-md-8 {
    right: 66.66667%;
  }
  .platform-core .pull-md-9,
  .platform-tablet .pull-md-9 {
    right: 75%;
  }
  .platform-core .pull-md-10,
  .platform-tablet .pull-md-10 {
    right: 83.33333%;
  }
  .platform-core .pull-md-11,
  .platform-tablet .pull-md-11 {
    right: 91.66667%;
  }
  .platform-core .pull-md-12,
  .platform-tablet .pull-md-12 {
    right: 100%;
  }
  .platform-core .push-md-0,
  .platform-tablet .push-md-0 {
    left: auto;
  }
  .platform-core .push-md-1,
  .platform-tablet .push-md-1 {
    left: 8.33333%;
  }
  .platform-core .push-md-2,
  .platform-tablet .push-md-2 {
    left: 16.66667%;
  }
  .platform-core .push-md-3,
  .platform-tablet .push-md-3 {
    left: 25%;
  }
  .platform-core .push-md-4,
  .platform-tablet .push-md-4 {
    left: 33.33333%;
  }
  .platform-core .push-md-5,
  .platform-tablet .push-md-5 {
    left: 41.66667%;
  }
  .platform-core .push-md-6,
  .platform-tablet .push-md-6 {
    left: 50%;
  }
  .platform-core .push-md-7,
  .platform-tablet .push-md-7 {
    left: 58.33333%;
  }
  .platform-core .push-md-8,
  .platform-tablet .push-md-8 {
    left: 66.66667%;
  }
  .platform-core .push-md-9,
  .platform-tablet .push-md-9 {
    left: 75%;
  }
  .platform-core .push-md-10,
  .platform-tablet .push-md-10 {
    left: 83.33333%;
  }
  .platform-core .push-md-11,
  .platform-tablet .push-md-11 {
    left: 91.66667%;
  }
  .platform-core .push-md-12,
  .platform-tablet .push-md-12 {
    left: 100%;
  }
  .platform-core .offset-md-0,
  .platform-tablet .offset-md-0 {
    margin-left: 0%;
  }
  .platform-core .offset-md-1,
  .platform-tablet .offset-md-1 {
    margin-left: 8.33333%;
  }
  .platform-core .offset-md-2,
  .platform-tablet .offset-md-2 {
    margin-left: 16.66667%;
  }
  .platform-core .offset-md-3,
  .platform-tablet .offset-md-3 {
    margin-left: 25%;
  }
  .platform-core .offset-md-4,
  .platform-tablet .offset-md-4 {
    margin-left: 33.33333%;
  }
  .platform-core .offset-md-5,
  .platform-tablet .offset-md-5 {
    margin-left: 41.66667%;
  }
  .platform-core .offset-md-6,
  .platform-tablet .offset-md-6 {
    margin-left: 50%;
  }
  .platform-core .offset-md-7,
  .platform-tablet .offset-md-7 {
    margin-left: 58.33333%;
  }
  .platform-core .offset-md-8,
  .platform-tablet .offset-md-8 {
    margin-left: 66.66667%;
  }
  .platform-core .offset-md-9,
  .platform-tablet .offset-md-9 {
    margin-left: 75%;
  }
  .platform-core .offset-md-10,
  .platform-tablet .offset-md-10 {
    margin-left: 83.33333%;
  }
  .platform-core .offset-md-11,
  .platform-tablet .offset-md-11 {
    margin-left: 91.66667%;
  }
}
@media (min-width: 992px) {
  .platform-core .col-lg-1,
  .platform-tablet .col-lg-1 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 8.33333%;
  }
  .platform-core .col-lg-2,
  .platform-tablet .col-lg-2 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 16.66667%;
  }
  .platform-core .col-lg-3,
  .platform-tablet .col-lg-3 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 25%;
  }
  .platform-core .col-lg-4,
  .platform-tablet .col-lg-4 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 33.33333%;
  }
  .platform-core .col-lg-5,
  .platform-tablet .col-lg-5 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 41.66667%;
  }
  .platform-core .col-lg-6,
  .platform-tablet .col-lg-6 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 50%;
  }
  .platform-core .col-lg-7,
  .platform-tablet .col-lg-7 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 58.33333%;
  }
  .platform-core .col-lg-8,
  .platform-tablet .col-lg-8 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 66.66667%;
  }
  .platform-core .col-lg-9,
  .platform-tablet .col-lg-9 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 75%;
  }
  .platform-core .col-lg-10,
  .platform-tablet .col-lg-10 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 83.33333%;
  }
  .platform-core .col-lg-11,
  .platform-tablet .col-lg-11 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 91.66667%;
  }
  .platform-core .col-lg-12,
  .platform-tablet .col-lg-12 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 100%;
  }
  .platform-core .pull-lg-0,
  .platform-tablet .pull-lg-0 {
    right: auto;
  }
  .platform-core .pull-lg-1,
  .platform-tablet .pull-lg-1 {
    right: 8.33333%;
  }
  .platform-core .pull-lg-2,
  .platform-tablet .pull-lg-2 {
    right: 16.66667%;
  }
  .platform-core .pull-lg-3,
  .platform-tablet .pull-lg-3 {
    right: 25%;
  }
  .platform-core .pull-lg-4,
  .platform-tablet .pull-lg-4 {
    right: 33.33333%;
  }
  .platform-core .pull-lg-5,
  .platform-tablet .pull-lg-5 {
    right: 41.66667%;
  }
  .platform-core .pull-lg-6,
  .platform-tablet .pull-lg-6 {
    right: 50%;
  }
  .platform-core .pull-lg-7,
  .platform-tablet .pull-lg-7 {
    right: 58.33333%;
  }
  .platform-core .pull-lg-8,
  .platform-tablet .pull-lg-8 {
    right: 66.66667%;
  }
  .platform-core .pull-lg-9,
  .platform-tablet .pull-lg-9 {
    right: 75%;
  }
  .platform-core .pull-lg-10,
  .platform-tablet .pull-lg-10 {
    right: 83.33333%;
  }
  .platform-core .pull-lg-11,
  .platform-tablet .pull-lg-11 {
    right: 91.66667%;
  }
  .platform-core .pull-lg-12,
  .platform-tablet .pull-lg-12 {
    right: 100%;
  }
  .platform-core .push-lg-0,
  .platform-tablet .push-lg-0 {
    left: auto;
  }
  .platform-core .push-lg-1,
  .platform-tablet .push-lg-1 {
    left: 8.33333%;
  }
  .platform-core .push-lg-2,
  .platform-tablet .push-lg-2 {
    left: 16.66667%;
  }
  .platform-core .push-lg-3,
  .platform-tablet .push-lg-3 {
    left: 25%;
  }
  .platform-core .push-lg-4,
  .platform-tablet .push-lg-4 {
    left: 33.33333%;
  }
  .platform-core .push-lg-5,
  .platform-tablet .push-lg-5 {
    left: 41.66667%;
  }
  .platform-core .push-lg-6,
  .platform-tablet .push-lg-6 {
    left: 50%;
  }
  .platform-core .push-lg-7,
  .platform-tablet .push-lg-7 {
    left: 58.33333%;
  }
  .platform-core .push-lg-8,
  .platform-tablet .push-lg-8 {
    left: 66.66667%;
  }
  .platform-core .push-lg-9,
  .platform-tablet .push-lg-9 {
    left: 75%;
  }
  .platform-core .push-lg-10,
  .platform-tablet .push-lg-10 {
    left: 83.33333%;
  }
  .platform-core .push-lg-11,
  .platform-tablet .push-lg-11 {
    left: 91.66667%;
  }
  .platform-core .push-lg-12,
  .platform-tablet .push-lg-12 {
    left: 100%;
  }
  .platform-core .offset-lg-0,
  .platform-tablet .offset-lg-0 {
    margin-left: 0%;
  }
  .platform-core .offset-lg-1,
  .platform-tablet .offset-lg-1 {
    margin-left: 8.33333%;
  }
  .platform-core .offset-lg-2,
  .platform-tablet .offset-lg-2 {
    margin-left: 16.66667%;
  }
  .platform-core .offset-lg-3,
  .platform-tablet .offset-lg-3 {
    margin-left: 25%;
  }
  .platform-core .offset-lg-4,
  .platform-tablet .offset-lg-4 {
    margin-left: 33.33333%;
  }
  .platform-core .offset-lg-5,
  .platform-tablet .offset-lg-5 {
    margin-left: 41.66667%;
  }
  .platform-core .offset-lg-6,
  .platform-tablet .offset-lg-6 {
    margin-left: 50%;
  }
  .platform-core .offset-lg-7,
  .platform-tablet .offset-lg-7 {
    margin-left: 58.33333%;
  }
  .platform-core .offset-lg-8,
  .platform-tablet .offset-lg-8 {
    margin-left: 66.66667%;
  }
  .platform-core .offset-lg-9,
  .platform-tablet .offset-lg-9 {
    margin-left: 75%;
  }
  .platform-core .offset-lg-10,
  .platform-tablet .offset-lg-10 {
    margin-left: 83.33333%;
  }
  .platform-core .offset-lg-11,
  .platform-tablet .offset-lg-11 {
    margin-left: 91.66667%;
  }
}
@media (min-width: 1200px) {
  .platform-core .col-xl-1,
  .platform-tablet .col-xl-1 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 8.33333%;
  }
  .platform-core .col-xl-2,
  .platform-tablet .col-xl-2 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 16.66667%;
  }
  .platform-core .col-xl-3,
  .platform-tablet .col-xl-3 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 25%;
  }
  .platform-core .col-xl-4,
  .platform-tablet .col-xl-4 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 33.33333%;
  }
  .platform-core .col-xl-5,
  .platform-tablet .col-xl-5 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 41.66667%;
  }
  .platform-core .col-xl-6,
  .platform-tablet .col-xl-6 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 50%;
  }
  .platform-core .col-xl-7,
  .platform-tablet .col-xl-7 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 58.33333%;
  }
  .platform-core .col-xl-8,
  .platform-tablet .col-xl-8 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 66.66667%;
  }
  .platform-core .col-xl-9,
  .platform-tablet .col-xl-9 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 75%;
  }
  .platform-core .col-xl-10,
  .platform-tablet .col-xl-10 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 83.33333%;
  }
  .platform-core .col-xl-11,
  .platform-tablet .col-xl-11 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 91.66667%;
  }
  .platform-core .col-xl-12,
  .platform-tablet .col-xl-12 {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
    float: left;
    width: 100%;
  }
  .platform-core .pull-xl-0,
  .platform-tablet .pull-xl-0 {
    right: auto;
  }
  .platform-core .pull-xl-1,
  .platform-tablet .pull-xl-1 {
    right: 8.33333%;
  }
  .platform-core .pull-xl-2,
  .platform-tablet .pull-xl-2 {
    right: 16.66667%;
  }
  .platform-core .pull-xl-3,
  .platform-tablet .pull-xl-3 {
    right: 25%;
  }
  .platform-core .pull-xl-4,
  .platform-tablet .pull-xl-4 {
    right: 33.33333%;
  }
  .platform-core .pull-xl-5,
  .platform-tablet .pull-xl-5 {
    right: 41.66667%;
  }
  .platform-core .pull-xl-6,
  .platform-tablet .pull-xl-6 {
    right: 50%;
  }
  .platform-core .pull-xl-7,
  .platform-tablet .pull-xl-7 {
    right: 58.33333%;
  }
  .platform-core .pull-xl-8,
  .platform-tablet .pull-xl-8 {
    right: 66.66667%;
  }
  .platform-core .pull-xl-9,
  .platform-tablet .pull-xl-9 {
    right: 75%;
  }
  .platform-core .pull-xl-10,
  .platform-tablet .pull-xl-10 {
    right: 83.33333%;
  }
  .platform-core .pull-xl-11,
  .platform-tablet .pull-xl-11 {
    right: 91.66667%;
  }
  .platform-core .pull-xl-12,
  .platform-tablet .pull-xl-12 {
    right: 100%;
  }
  .platform-core .push-xl-0,
  .platform-tablet .push-xl-0 {
    left: auto;
  }
  .platform-core .push-xl-1,
  .platform-tablet .push-xl-1 {
    left: 8.33333%;
  }
  .platform-core .push-xl-2,
  .platform-tablet .push-xl-2 {
    left: 16.66667%;
  }
  .platform-core .push-xl-3,
  .platform-tablet .push-xl-3 {
    left: 25%;
  }
  .platform-core .push-xl-4,
  .platform-tablet .push-xl-4 {
    left: 33.33333%;
  }
  .platform-core .push-xl-5,
  .platform-tablet .push-xl-5 {
    left: 41.66667%;
  }
  .platform-core .push-xl-6,
  .platform-tablet .push-xl-6 {
    left: 50%;
  }
  .platform-core .push-xl-7,
  .platform-tablet .push-xl-7 {
    left: 58.33333%;
  }
  .platform-core .push-xl-8,
  .platform-tablet .push-xl-8 {
    left: 66.66667%;
  }
  .platform-core .push-xl-9,
  .platform-tablet .push-xl-9 {
    left: 75%;
  }
  .platform-core .push-xl-10,
  .platform-tablet .push-xl-10 {
    left: 83.33333%;
  }
  .platform-core .push-xl-11,
  .platform-tablet .push-xl-11 {
    left: 91.66667%;
  }
  .platform-core .push-xl-12,
  .platform-tablet .push-xl-12 {
    left: 100%;
  }
  .platform-core .offset-xl-0,
  .platform-tablet .offset-xl-0 {
    margin-left: 0%;
  }
  .platform-core .offset-xl-1,
  .platform-tablet .offset-xl-1 {
    margin-left: 8.33333%;
  }
  .platform-core .offset-xl-2,
  .platform-tablet .offset-xl-2 {
    margin-left: 16.66667%;
  }
  .platform-core .offset-xl-3,
  .platform-tablet .offset-xl-3 {
    margin-left: 25%;
  }
  .platform-core .offset-xl-4,
  .platform-tablet .offset-xl-4 {
    margin-left: 33.33333%;
  }
  .platform-core .offset-xl-5,
  .platform-tablet .offset-xl-5 {
    margin-left: 41.66667%;
  }
  .platform-core .offset-xl-6,
  .platform-tablet .offset-xl-6 {
    margin-left: 50%;
  }
  .platform-core .offset-xl-7,
  .platform-tablet .offset-xl-7 {
    margin-left: 58.33333%;
  }
  .platform-core .offset-xl-8,
  .platform-tablet .offset-xl-8 {
    margin-left: 66.66667%;
  }
  .platform-core .offset-xl-9,
  .platform-tablet .offset-xl-9 {
    margin-left: 75%;
  }
  .platform-core .offset-xl-10,
  .platform-tablet .offset-xl-10 {
    margin-left: 83.33333%;
  }
  .platform-core .offset-xl-11,
  .platform-tablet .offset-xl-11 {
    margin-left: 91.66667%;
  }
}
.platform-core .clickable,
.platform-tablet .clickable {
  cursor: pointer;
}
.platform-core .blur,
.platform-tablet .blur {
  -webkit-filter: blur(10px);
  filter: blur(10px);
  pointer-events: none;
  cursor: default;
}
.platform-core .map,
.platform-tablet .map {
  display: block;
}
.platform-core .map .sebm-google-map-container,
.platform-tablet .map .sebm-google-map-container {
  width: 100%;
  height: 200px;
}
.platform-core .no-padding,
.platform-tablet .no-padding {
  padding: 0;
}
.platform-core .app-root,
.platform-tablet .app-root {
  right: 0;
}
.platform-core .full-width-bg,
.platform-tablet .full-width-bg {
  width: 100%;
}
.platform-core .full-width-bg.home,
.platform-tablet .full-width-bg.home {
  min-height: 70%;
  background-image: url("browser/media/home_big_family_optimized.jpg");
  background-size: cover;
  background-position: 50% 20%;
}
.platform-core .full-width-bg.green,
.platform-tablet .full-width-bg.green {
  background: #94C11F;
  color: white;
}
.platform-core .no-gutter > [class*=col-],
.platform-tablet .no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}
#CybotCookiebotDialog {
  width: 750px !important;
  margin-left: 270px !important;
  box-shadow: 0px 30px 70px rgba(0, 0, 0, 0.63) !important;
  border-radius: 8px !important;
  padding: 27px !important;
}
#CybotCookiebotDialogPoweredbyCybot {
  display: none !important;
}
#CybotCookiebotDialogBodyContentText {
  line-height: 1.631 !important;
  margin-bottom: 10px !important;
}
.CybotCookiebotDialogBodyButton {
  border-radius: 0.25em !important;
  padding: 0.45em !important;
  width: 160px !important;
  height: 20px !important;
}
.CybotCookiebotDialogBodyLink {
  color: #00b6e8 !important;
}
#CybotCookiebotDialogBodyContent {
  font-size: 0.94rem !important;
}
#CybotCookiebotDialogBodyContentTitle {
  margin: 4px 0 17px !important;
}
#CybotCookiebotDialogBodyButtonDetails {
  font-size: 0.69rem !important;
  font-weight: 600 !important;
  color: #00b6e8 !important;
}
#CybotCookiebotDialogBodyButtonDecline {
  color: black;
  background-color: white;
  border: 1px solid #00b6e8;
}
@media (max-width: 1000px) {
  #CybotCookiebotDialog {
    width: 100% !important;
    margin-left: 0 !important;
  }
}
.menu-footer {
  background-color: #313131 !important;
}
#fullcalendar {
  z-index: 999;
}
nav ul {
  list-style: none;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
}
nav ul li {
  position: relative;
}
nav ul li ul {
  display: block;
  position: absolute;
  z-index: 999;
}
nav ul li ion-item {
  color: #003578;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
  z-index: 1;
}
nav ul li .dropdown-arrow {
  margin-left: 5px;
}
.dropdown-menu {
  position: absolute;
  z-index: 9999;
  top: 50px;
  left: 0;
  background-color: white;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 10px 0;
  margin: 0;
  border-radius: 10px;
}
.dropdown-menu li {
  display: none;
  padding: 8px 16px;
  white-space: nowrap;
}
nav ul li:hover .dropdown-menu li {
  display: block;
  z-index: 999;
  transition: 0.5s;
}
app-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .main-section,
  .about,
  .career,
  .advantages,
  .termmed-app {
    flex-direction: column;
  }
  .mobile-nav-container {
    padding: var(--top-margin) var(--side-margins);
  }
  .login-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--text-spacing);
  }
  .login-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .mobile-nav ul {
    list-style: none;
    padding: 0;
  }
  .mobile-nav ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--text-spacing);
  }
  .mobile-nav ul li ion-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .social-buttons {
    display: block;
    justify-content: space-between;
    margin-bottom: var(--button-spacing);
  }
  .social-buttons ion-button {
    width: auto;
    height: auto;
    font-size: 1.25rem;
  }
  .contact-button {
    text-align: center;
    color: var(--termed-blau);
  }
  .contact-button ion-button {
    color: #003578;
    width: auto;
    height: auto;
    font-size: 1rem;
  }
  .articles {
    display: none;
  }
  .search-container {
    display: none;
  }
  .topnav,
  .more {
    display: none;
  }
  .main-section .text-content,
  .about .text-content,
  .career .text-content,
  .advantages .text-content,
  .termmed-app .text-content {
    max-width: 100%;
    text-align: center;
  }
  .main-section img,
  .about img,
  .career img,
  .advantages img,
  .termmed-app img {
    max-width: 100%;
    margin-top: 20px;
  }
  .products {
    flex-direction: column;
    text-align: center;
  }
  .products .content-container {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .products .product-image {
    max-width: 100%;
  }
  .header-container {
    flex-direction: column;
    align-items: center;
  }
  .login-buttons {
    margin-top: 10px;
  }
  nav ul {
    flex-direction: column;
    gap: 10px;
  }
}
.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.content {
  flex: 1;
}
.togglelang {
  color: #cecece !important;
  background-color: #313131 !important;
}
.design {
  margin: 20px;
  display: inline;
}
:host {
  background-color: white, !important;
}
.social-icons {
  display: flex;
  gap: 10px;
}
.social-icons ion-img {
  width: 24px;
  height: 24px;
}
.buttons {
  margin-top: 10px;
}
.buttons ion-button {
  margin-right: 10px;
}
.buttons ion-button ion-img {
  width: 20px;
  height: auto;
  margin-right: 5px;
}
.legal-links {
  list-style-type: none;
  display: flex;
  gap: 15px;
  padding: 0;
}
.legal-links li a {
  text-decoration: none;
  color: #003578;
}
.legal-links li a:hover {
  text-decoration: underline;
}
.circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.circle.black {
  background-color: #000000;
}
.circle.red {
  background-color: #FF0000;
}
.circle.gold {
  background-color: #FFCC00;
}
.menu-home-button-logo {
  width: 160px;
  height: 64px;
  margin: 2.5px 0;
  --background: url(/assets/images/newDesign/Logo_00_Termed_Logo_Blau.png) no-repeat center/cover;
}
.change-language-menu-button {
  width: 64px;
  height: 42px;
}
.change-language-menu-button.de {
  --background: url(/assets/i18n/DE.svg) no-repeat center/cover;
}
.change-language-menu-button.en {
  --background: url(/assets/i18n/GB.svg) no-repeat center/cover;
}
/*# sourceMappingURL=browser/app.component.css.map */
